module.exports = __webpack_public_path__ + "assets/img/kv-77bea209.jpg";